import { render, staticRenderFns } from "./expiring-soon.vue?vue&type=template&id=8e8e3e2c&scoped=true&"
import script from "./expiring-soon.vue?vue&type=script&lang=js&"
export * from "./expiring-soon.vue?vue&type=script&lang=js&"
import style0 from "./expiring-soon.vue?vue&type=style&index=0&id=8e8e3e2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8e3e2c",
  null
  
)

export default component.exports